// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';
import $ from 'jquery';

const fragments = {
  HAMBURGER: '[data-fragment="LandingHeader.hamburger"]',
  BACKDROP: '[data-fragment="LandingHeader.backdrop"]',
  LINK: '[data-fragment="LandingHeader.link"]',
  SLIDER: '[data-fragment="LandingHeader.slider"]',
  SECTION: '[data-fragment="LandingHeader.section"]',
};

export default class LandingHeader extends WebComponent {
  constructor(props) {
    super(props);

    this.state = {
      menuOpened: false,
      headerScrolled: false,
      activeLinkId: null,
      sliderVisible: false,
    };

    this.toggleMenu = this.toggleMenu.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.slideTo = this.slideTo.bind(this);
    this.handleLinkClick = this.handleLinkClick.bind(this);
    this.isElementInViewport = this.isElementInViewport.bind(this);
    this.handlePageload = this.handlePageload.bind(this);
    this.scrollTo = this.scrollTo.bind(this);
  }

  didMount() {
    this.on('click', fragments.HAMBURGER, this.toggleMenu);
    this.on('click', fragments.BACKDROP, this.toggleMenu);
    this.on('click', fragments.LINK, this.handleLinkClick);
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleScroll);
    this.slider = this.element.querySelector(fragments.SLIDER);
    this.sections = document.body.querySelectorAll(fragments.SECTION);
    this.links = document.body.querySelectorAll(fragments.LINK);
    this.handleScroll();
    this.handlePageload();
  }

  toggleMenu = () => {
    const { menuOpened } = this.state;
    this.setState({
      menuOpened: !menuOpened,
    });
  };

  handleScroll = () => {
    if (window.innerWidth >= 1200) {
      if (window.scrollY > 100) {
        this.setState({
          headerScrolled: true,
        });
      } else {
        this.setState({
          headerScrolled: false,
        });
      }
      this.setState({
        activeLinkId: null,
        sliderVisible: false,
      });
      for (let i = 0; i < this.sections.length; i++) {
        if (this.isElementInViewport(this.sections[i])) {
          this.setState({
            activeLinkId: this.sections[i].dataset.target,
            sliderVisible: true,
          });
        }
      }
    }
  };

  slideTo = (el) => {
    const left = el.getBoundingClientRect().left - this.element.getBoundingClientRect().left;
    this.slider.style.left = `${left}px`;
    this.slider.style.width = `${el.offsetWidth}px`;
  };

  handleLinkClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const href = e.target.getAttribute('href');
    const hash = `#${href.substring(href.indexOf('#') + 1)}`;
    this.scrollTo(hash);
    window.location.hash = hash;
  };

  isElementInViewport = (el) => {
    const scrollPosition = window.pageYOffset + (window.innerHeight / 2);
    const elStart = el.offsetTop;
    const elEnd = el.offsetTop + el.offsetHeight;
    return (scrollPosition > elStart && scrollPosition < elEnd);
  };

  handlePageload = () => {
    const hash = window.location.hash;
    if (hash) {
      this.scrollTo(hash);
    }
  };

  scrollTo = (sectionId) => {
    const offset = this.element.offsetHeight;
    const target = document.body.querySelector(sectionId);
    $('html, body').animate({ scrollTop: target.offsetTop - offset }, 500);
    this.setState({
      menuOpened: false,
    });
  };

  willUnMount() {
  }

  update() {
    const {
      menuOpened, headerScrolled, activeLinkId, sliderVisible,
    } = this.state;
    classNames(document.body, { 'overflow-hidden': menuOpened });
    classNames(this.element, { 'landing-header--menu-opened': menuOpened });
    classNames(this.element, { 'landing-header--scrolled': headerScrolled });
    classNames(this.slider, { 'landing-header__slider--visible': sliderVisible });
    if (activeLinkId) {
      this.slideTo(this.element.querySelector(activeLinkId));
    }
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/LandingHeader.js